import { Table } from "../components/admin-ui";
import type { TableProps } from "../components/admin-ui";
import { useTranslation } from "react-i18next";

/**
 * DataTable — thin wrapper around Ant Design Table with KawKaw defaults:
 * - Sticky header
 * - Row hover amber tint (via theme token)
 * - Size = "middle"
 * - Pagination: 10 per page, show total
 */
export function DataTable<T extends object>(props: TableProps<T>) {
  const { t } = useTranslation();
  const pagination =
    props.pagination === false
      ? false
      : {
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
          showTotal: (total: number, range: [number, number]) =>
            t("common.tablePageRange", { start: range[0], end: range[1], total }),
          ...((props.pagination as object) ?? {}),
        };

  return (
    <Table<T>
      {...props}
      size={props.size ?? "middle"}
      scroll={props.scroll ?? { x: "max-content" }}
      sticky={props.sticky ?? { offsetHeader: 64 }}
      pagination={pagination}
      rowKey={props.rowKey ?? "id"}
    />
  );
}
